import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "row mb-1" };
const _hoisted_2 = { class: "col-6 text-truncate" };
const _hoisted_3 = { class: "col-6" };
const _hoisted_4 = { class: "flex-fill text-end fw-bold" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_link = _resolveComponent("g-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        _createElementVNode("div", _hoisted_3, [
            (_ctx.data[_ctx.field.member])
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.data[_ctx.field.member], (tFile) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: tFile.fileID,
                        class: "d-flex flex-row"
                    }, [
                        _createElementVNode("div", _hoisted_4, [
                            (tFile.fileUrl)
                                ? (_openBlock(), _createBlock(_component_g_link, {
                                    key: 0,
                                    src: tFile.fileUrl,
                                    target: "_blank"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tFile.name), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["src"]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(_toDisplayString(tFile.name), 1)
                                ], 64))
                        ])
                    ]));
                }), 128))
                : _createCommentVNode("", true)
        ])
    ]));
}
